<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">添加标签</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        <div class="write-txt">
          <p class="write-title"><span>*</span>标签类型：</p>
          <div class="write-text">
            <el-select v-model="addObj.type" placeholder="请选择">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>一级标签名称：</p>
          <div class="write-text">
            <div style="display: inline-block;vertical-align: top;">
              <input type="text" v-model="addObj.title" placeholder="最多输入30个中/英、数字和特殊行号">
              <!-- <span>最多输入30个中/英、数字和特殊行号</span> -->
            </div>
            <button class="btn btn-add" @click="addTwo()">添加二级标签</button>
          </div>

          <div class="label-list secondLabel" v-for="(item,index) in addObj.two_list" :key="index">
            <div class="write-txt">
              <p class="write-title">二级标签名称：</p>
              <div class="write-text">
                <div style="display: inline-block;vertical-align: top;">
                  <input type="text" v-model="item.title" placeholder="最多输入30个中/英、数字和特殊行号">
                  <!-- <span>最多输入30个中/英、数字和特殊行号</span> -->
                </div>
                <button class="btn btn-add" @click="addThree(item)">添加三级标签</button>
                <button class="btn btn-remove" @click="removeTwo(index)">删除</button>
              </div>
              <div class="label-list thirdLabel" v-for="(ele,num) in item.three_list" :key="num">
                <div class="write-txt">
                  <p class="write-title">三级标签名称：</p>
                  <div class="write-text">
                    <div style="display: inline-block;vertical-align: top;">
                      <input type="text" v-model="ele.title" placeholder="最多输入30个中/英、数字和特殊行号">
                      <!-- <span>最多输入30个中/英、数字和特殊行号</span> -->
                    </div>
                    <button class="btn btn-remove" @click="removeThree(index,num)">删除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加标签</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>标签类型名称:</p>
              <el-select v-model="obj.type" placeholder="请选择">
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">标签列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.type==1?'文章':'题干'">{{item.type==1?'文章':'题干'}}</p>
              <p :title="item.one_title">{{item.one_title}}</p>
              <p :title="item.two_title">{{item.two_title}}</p>
              <p :title="item.three_title">{{item.three_title}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLabelList , getSelectLabelTypeList,saveLabelDetail ,getLabelDetail ,delLabelDetail} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import cityJson from './../assets/json/city.json'
export default {
  name: "index",
  data() {
    return {
      navId:'3',
      titleList:[
        {id:1,title:'序号'},
        {id:5,title:'标签类型'},
        {id:2,title:'一级标签名称'},
        {id:3,title:'二级标签名称'},
        {id:4,title:'三级标签名称'},
        {id:6,title:'创建时间'},
        {id:7,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        title:'',
        type:''
      },
      totalPage:0,
      removeID:'',
      url:'',
      sortList:[
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'},
      ],
      typeList:[
        {id:1,name:'文章',value:1},
        {id:2,name:'题干',value:2},
      ],
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    // this.getTypeList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getTypeList(){
      var that = this;
      try {
        const response = await getSelectLabelTypeList(this.token);
        if(response.code == 200){
          that.typeList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getList(){
      var that = this;
      try {
        const response = await getLabelList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    addTwo(e){
      if(this.addObj.two_list){
        this.addObj.two_list.push({title:''})
      } else {
        this.addObj.two_list = [];
        this.addObj.two_list.push({title:''})
      }
      this.$forceUpdate();
    },

    removeTwo(index){
      this.addObj.two_list.splice(index,1);
      this.$forceUpdate();
    },

    removeThree(index,num){
      this.addObj.two_list[index].three_list.splice(num,1);
      this.$forceUpdate();
    },

    addThree(e){
      if(e.three_list){
        e.three_list.push({title:''})
      } else {
        e.three_list = [];
        e.three_list.push({title:''})
      }
      this.$forceUpdate();
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getLabelDetail({one_id:e.one_id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = {
            type:response.data.type,
            one_id:response.data.one_id,
            title:response.data.title,
            two_list:response.data.two_list,
          };
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.one_id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delLabelDetail({one_id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.type == ''){
        that.$message('请选择类型！');
        return false;
      }
      if(this.addObj.title == ''){
        that.$message('请输入一级标签！');
        return false;
      }
      try {
        const response = await saveLabelDetail(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {}
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.getList();
      } else {
        that.$message(response.msg);
      };
      that.loading = false;
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={};
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 7 );
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 20px;
  display: inline-block;
  margin-left: 20px;
}

.label-list{
  margin-top: 20px;
  margin-left: 160px;
}

.write-text  .btn-remove,
.write-text .btn-add{
  display: inline-block;
  vertical-align: top;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #fff;
  border-radius: 6px;
  background-color: #6098F2;
  margin-left: 20px;
  padding: 0 30px;
}

.write-text  .btn-remove{
  background-color: #E2231A;
  background-image: none;
  width: auto;
}


.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-remove{
  font-size: 20px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/label/index.vue